import { render, staticRenderFns } from "./parent-detail.vue?vue&type=template&id=2bdf37b6"
import script from "./parent-detail.vue?vue&type=script&lang=ts"
export * from "./parent-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports